import { useDraggable, useDroppable } from "@dnd-kit/core";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/** Id prefix for the synthetic "drop above first row" droppable. */
export const DROP_BEFORE_PREFIX = "drop-before-";

/** Draggable handle for a row; useDraggable must be used in a component that receives id. */
export function BoQDragHandle({ rowId, readOnly }) {
    const { attributes, listeners, setNodeRef } = useDraggable({ id: rowId });
    if (readOnly) {
        return <span className="boq-grid-drag-handle boq-grid-drag-handle--disabled"><FontAwesomeIcon icon={faBars} /></span>;
    }
    return (
        <span
            ref={setNodeRef}
            className="boq-grid-drag-handle"
            {...listeners}
            {...attributes}
            onClick={(e) => e.stopPropagation()}
        >
            <FontAwesomeIcon icon={faBars} />
        </span>
    );
}

/** Invisible droppable row at top of tbody so "drop above first row" shows the blue line. */
export function BoQDropBeforeRow({ firstRowId, colSpan }) {
    const id = `${DROP_BEFORE_PREFIX}${firstRowId}`;
    const { setNodeRef } = useDroppable({ id });
    return (
        <tr ref={setNodeRef} className="boq-grid-drop-slot" aria-hidden="true">
            <td colSpan={colSpan} />
        </tr>
    );
}

/** Table row with droppable. Drop indicator is rendered as a floating bar by the grid. */
export function BoQTableRow({ row, children, className, style, dropIndicator, onCanDrop, ...trProps }) {
    const { setNodeRef } = useDroppable({ id: row.original.id });
    return (
        <tr ref={setNodeRef} data-row-id={row.original.id} className={className} style={style} {...trProps}>
            {children}
        </tr>
    );
}
